import { Component, Input, ElementRef, ViewChildren, Injector } from '@angular/core';
import { Events } from 'ionic-angular';
import { Domanda_super } from './domanda_super';
import { TranslateService } from '@ngx-translate/core';





/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'multipla_1',
  templateUrl: 'multipla_1.html',
})

export class Multipla_1Component extends Domanda_super {

  @Input('domanda') domanda: any;
  @Input('mq') mq: any;
  @Input('settingsmq') settingsmq: any;
  @ViewChildren('ion-checkbox') questions: ElementRef;
  output: any;
  risp: any = [];
  risp_id: any = [];
  risposte_conferma = [];
  showconferma: boolean = true;
  showfeed: boolean = false;
  feed = '';
  showtime: boolean = true;
  constructor(public events: Events, inj: Injector, public translate: TranslateService) {
    super(inj);
    this.output = 'test string';

  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.events.publish('start_tempo', this.domanda);
    if (this.settingsmq.risposteCausali == '1')
      this.domanda['RispostaMicroStepList'] = this.shuffle(this.domanda['RispostaMicroStepList']);
    //console.log(this.domanda.durataMinima);
    if (this.domanda.durataMinima != '0') {
      this.showtime = false;
    }
    this.events.subscribe('tempo_' + this.domanda.id, (tipotempo) => {
      if (tipotempo == 'minima')
        this.showtime = true;
      else if (tipotempo == 'massima')
        this.conferma('tempo');
    });
  }
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    for (let i = 0; i < this.domanda['RispostaMicroStepList'].length; i++) {
      let r = this.domanda['RispostaMicroStepList'][i];
      var hradio = document.getElementById('item_' + r.id).clientHeight;
      var radio_icon = document.getElementById(r.id).children[0];
      radio_icon.setAttribute("style", "height:" + hradio + "px !important");
      radio_icon.children[0].setAttribute("style", "height:" + (hradio - 22) + "px !important");
      // radio_icon.children[0].setAttribute("style", "height:" + (hradio - 10) + "px !important");
    }
  }

  changestyle(esatte, errate, esatte_date) {

    var x = document.getElementsByTagName("ion-checkbox");
    var i;
    for (i = 0; i < x.length; i++) {
      var l = x[i];
      if (esatte_date.indexOf(l['id']) != -1) {
        l.children[0].children[0].classList.add('baffo');
        l.children[0].classList.add('green');
      }
      else if (esatte.indexOf(l['id']) != -1) {
        //l.children[0].children[0].classList.add('baffo');
        l.children[0].classList.add('green');
      }
      else if (errate.indexOf(l['id']) != -1) {
        l.children[0].classList.add('red');
        l.children[0].children[0].classList.add('baffox');
      }
    }
  }
  sel(id) {
    if (this.risp_id.indexOf(id) == -1) {
      this.risp_id.push(id);
    }
    else {
      var index = this.risp_id.indexOf(id);
      this.risp_id.splice(index, 1);
    }
    //this.update_output(this.risp_id);
    this.risposte_conferma = this.risp_id;
  }

  prosegui() {
    this.events.publish('stop_tempo', this.domanda);
    this.events.publish('multipla', this.domanda, this.risposte_conferma);
  }

  conferma(tempo?) {
    //console.log(this.risposte_conferma);

    let r_esatte = [];
    for (let i = 0; i < this.domanda['RispostaMicroStepList'].length; i++) {
      let r = this.domanda['RispostaMicroStepList'][i];
      if (r.punti > 0)
        r_esatte.push(r.id);
    }
    this.translate.get(['domande.ERRRISPOSTE', 'domande.ERRNRISPOSTE'], { numero: r_esatte.length }).subscribe(v => {
      if (this.risposte_conferma.length == 0 && tempo != 'tempo') {
        // this.showfeed = true;
        // this.feed = 'Non hai inserito nessuna risposta';

        this.presentToast(v['domande.ERRRISPOSTE']);
        return;
        // })
      }
      else if (this.risposte_conferma.length < r_esatte.length && tempo != 'tempo') {
        this.showfeed = true;
        // this.feed = 'Non hai inserito tutte le '+r_esatte.length+' risposte';
        // this.translate.get('domande.ERRNRISPOSTE',{numero:r_esatte.length}).subscribe(v => {
        this.presentToast(v['domande.ERRNRISPOSTE']);
        return;
        // });
      }

      this.events.publish('stop_tempo_parziale', this.domanda);
      let risp_esatte = [];
      let risp_errate = [];

      let r_esatte_date = [];
      let num_esatte_date = 0;

      for (let i = 0; i < this.risposte_conferma.length; i++) {
        let rdata = this.risposte_conferma[i];

        if (r_esatte.indexOf(rdata) == -1) {
          risp_errate.push(rdata);
        }
        if (r_esatte.indexOf(rdata) != -1) {
          r_esatte_date.push(rdata);
          num_esatte_date++;
        }
      }
      //console.log('esatte', risp_esatte);
      //console.log('errate', risp_errate);
      if (!this.settingsmq['istest'])
        this.changestyle(r_esatte, risp_errate, r_esatte_date);

      // if(tempo == 'tempo'){
      //   //se scade il tempo

      // }
      // else{

      // }

      if (risp_errate.length == 0 && tempo != 'tempo')
        this.feed = this.domanda['feedbackPositivo'];
      else if (risp_errate.length == 0 && tempo == 'tempo' && num_esatte_date == r_esatte.length)
        this.feed = this.domanda['feedbackPositivo'];
      // else if(num_esatte_date == r_esatte.length)
      //   this.feed = this.domanda['feedbackPositivo'];
      else if (num_esatte_date > 0)
        this.feed = this.domanda['feedbackParziale'];
      else
        this.feed = this.domanda['feedbackNegativo'];

      this.showfeed = true;
      this.showconferma = false;
      if (this.settingsmq['istest'])
        this.prosegui();
    });
  }
  shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }

}



// WEBPACK FOOTER //
// ./src/pages/msteps/multipla_1.ts